import PropTypes from 'prop-types';
import React from 'react';

import { cn, DefaultTooltip } from 'twyne-new.ui';

const propTypes = {
  maxLength: PropTypes.number,
  id: PropTypes.string,
  placement: PropTypes.string,
};

export default function TextTruncated({ children: text, maxLength, placement, className = '' }) {
  if (`${text}`.length <= maxLength) return <div className={className}>{text}</div>

  return <div>
    <DefaultTooltip content={text} side={placement} contentProps={{ className: 'break-words' }}>
      <div className={cn('cursor-pointer', className)}>
        {`${text}`.substring(0, maxLength).trim()}
        <span>...</span>
      </div>
    </DefaultTooltip>
  </div>
}

TextTruncated.propTypes = propTypes
TextTruncated.defaultProps = {
  placement: "right",
}
